<template>
   <EquipmentBoxBrain v-if="type === 'box'" />
   <EquipmentBoxVenueBrain v-else-if="type === 'box-venue'" />
</template>

<script>
import EquipmentBoxBrain from './EquipmentBox/EquipmentBoxBrain.vue';
import EquipmentBoxVenueBrain from './EquipmentBoxVenue/EquipmentBoxVenueBrain.vue';

export default {
   components: {
      EquipmentBoxBrain,
      EquipmentBoxVenueBrain
   },

   data() {
      return {
         type: ''
      }
   },

   mounted() {
      this.type = this.$util.getUrlParam("type");
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// EquipmentBrain.vue?2a05739f